import { render, staticRenderFns } from "./PreferencesDetail.vue?vue&type=template&id=301d3022&scoped=true"
import script from "./PreferencesDetail.vue?vue&type=script&lang=js"
export * from "./PreferencesDetail.vue?vue&type=script&lang=js"
import style0 from "./PreferencesDetail.vue?vue&type=style&index=0&id=301d3022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301d3022",
  null
  
)

export default component.exports